import { InputBaseReactComponent } from './../input-base-react/input-base-react.component';
import { Component, forwardRef, Input, OnChanges, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-input-boolean-react',
  templateUrl: './input-boolean-react.component.html',
  styleUrls: ['./input-boolean-react.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputBooleanReactComponent),
      multi: true
    }
  ]
})

export class InputBooleanReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges {

  //#region .  Inputs  .
  @Input() trueDetailText?: string = undefined;

  @Input() falseDetailText?: string = undefined;
  //#endregion

  //#region .  Construtor  .
  constructor() {
    super();
  }
  //#endregion

  ngOnInit(): void {
    super.ngOnInit();
    this.setAndUpdateValidators();

    if (!this.trueDetailText) {
      this.trueDetailText = 'Ativo';
    }

    if (!this.falseDetailText) {
      this.falseDetailText = 'Inativo';
    }
  }

  ngOnChanges(): void {
    super.ngOnChanges();
    this.setAndUpdateValidators();
  }

  // overload de método existente na classe base, para inputs do tipo "checkbox" utiliza-se a propriedade "checked"
  // e não a propriedade "value"
  public changeValue(event): void {
    const newValue = (this.field.nativeElement.checked === true ? false : true);
    this.value = newValue;
    this.onChange(newValue);
    this.onTouched();
  }

  public detailModeText(): string {
    const val = this.value.toString()
      .toLowerCase();

    if (val === 'true') {
      return this.trueDetailText;
    } else {
      return this.falseDetailText;
    }
  }
}
